import { setActiveCommunityId } from 'community/state/communitySlice';
import type { Effect } from 'store';
import { setShowMemberSetupDialog } from 'user/state';

import { communityApi } from './communityApi';
import { selectHasNoCommunity } from './selectors';
import { RegisteredToCommunityActionPayload } from './types';

export const registerToCommunitySuccessEffect: Effect = ({ payload }, { dispatch }) => {
  const { communityId, showMemberSetupDialog = true } = payload as RegisteredToCommunityActionPayload;
  if (!communityId) return;

  dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
  dispatch(setActiveCommunityId(communityId));
  if (showMemberSetupDialog) {
    dispatch(setShowMemberSetupDialog(true));
  }
};

export const invalidateMyCommunitiesEffect: Effect = (_, { dispatch, getState }) => {
  const state = getState();

  const hasNoCommunity = selectHasNoCommunity(state);
  if (hasNoCommunity) {
    dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
  }
};
